import settings from '@/settings'

let atualizarImagemPerfil = (imagem, headers) => {
  return fetch(`${settings.apetrusApi}/pessoas/atualizarimagemperfil/`, {
    method: 'PUT',
    body: JSON.stringify(imagem),
    mode: 'cors',
    headers: headers
  })
}

let insert = (data, headers) => {
  return fetch(`${settings.apetrusApi}/pessoas/cadastrar_por_administrador/`, {
    method: 'POST',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

let atualizarEndereco = (data, headers) => {
  return fetch(`${settings.apetrusApi}/pessoas/atualizarenderecoporadministrador/`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

let paginated = (page, filtros, headers) => {
  let url = `${settings.apetrusApi}/pessoas/paginated/?page=${page}`
  Object.keys(filtros).forEach((filter) => {
    url = `${url}&${filter}=${filtros[filter]}`
  })
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    headers: headers
  })
}

let pending = (headers) => {
  return fetch(`${settings.apetrusApi}/pessoas/pending/`, {
    method: 'GET',
    mode: 'cors',
    headers: headers
  })
}

let verifyUser = (userid, validation, option, motivo, headers) => {
  return fetch(`${settings.apetrusApi}/pessoas/pending/?userid=${userid}`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify({
      validation: validation,
      option: option,
      motivo: motivo
    }),
    headers: headers
  })
}

let auth = (headers) => {
  return fetch(`${settings.apetrusApi}/pessoas/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let procurarPessoasPorAdm = (headers, payload) => {
  let url = `${settings.apetrusApi}/pessoas/procurarPessoasPorAdm/?`
  Object.keys(payload.filtros).forEach((filter) => {
    url = `${url}&${filter}=${payload.filtros[filter]}`
  })
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    headers: headers
  })
}

let cadSmartLock = (headers, data) => {
  return fetch(`${settings.apetrusApi}/pessoas/cadastrarsmartlock/`, {
    method: 'POST',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

let apagarPessoa = (headers, payload) => {
  return fetch(`${settings.apetrusApi}/pessoas/`, {
    method: 'DELETE',
    body: JSON.stringify(payload),
    mode: 'cors',
    headers: headers
  })
}

let updatePessoa = (headers, payload) => {
  return fetch(`${settings.apetrusApi}/pessoas/${payload.id_pessoa}/`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify(payload),
    headers: headers
  })
}

let verificarTelefone = (headers, payload) => {
  let url = `${settings.apetrusApi}/pessoas/${payload.id_pessoa}/verificar-telefone/${payload.telefone}/`
  if (payload.filtros) {
    Object.keys(payload.filtros).forEach((filter) => {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${payload.filtros[filter]}`
    })
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const pegarPorId = (headers, data) => {
  let url = `${settings.apetrusApi}/pessoas/pegar-por-id/`
  if (data) {
    const keys = Object.keys(data)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${data[keys[i]]}`
    }
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  atualizarImagemPerfil,
  insert,
  atualizarEndereco,
  paginated,
  auth,
  pending,
  verifyUser,
  procurarPessoasPorAdm,
  cadSmartLock,
  apagarPessoa,
  updatePessoa,
  verificarTelefone,
  pegarPorId
}
